<div #graph>
</div>

<div class="key"><div style="background:#7753D3;"></div> <span>% coverage</span></div>
<div class="key"><div style="background:#9AC231;"></div> <span>Relative % identity</span></div>
<div class="key"><div style="background:#AAAAAA;"></div> <span>Number of hits with an insertion</span></div>
